export default "__VITE_ASSET__BXkPyexx__"